import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Region } from "src/app/shared/models/region";

@Injectable({
  providedIn: "root",
})
export class RegionService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}Region`;

  public createRegion(code: string, description: string): Observable<Region> {
    return this.http.post<Region>(
      `${this.apiRoot}/createRegion/code=${code}/description=${description}`,
      null
    );
  }

  public getRegion(code: string): Observable<Region> {
    return this.http.get<Region>(`${this.apiRoot}/getRegion/${code}`);
  }

  public getAllRegions(): Observable<Region[]> {
    return this.http.get<Region[]>(`${this.apiRoot}/getAllRegions`);
  }

  public deleteRegion(code: string): Observable<Region> {
    return this.http.delete<Region>(`${this.apiRoot}/deleteRegion/${code}`);
  }
}
